<template>
    <div
        class="value"
        :class="{selected: chosen}"
        @click="$emit('click')"
        @keyup="$emit('keyup')">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Box',
    props: [
        'chosen'
    ]
}
</script>
